import styled from 'styled-components';

const Divider = styled.div`
  height: 25px;
  background-color: #f6f6f6;
`;

export default Divider;
